import React from 'react';
import Form from 'react-bootstrap/Form'
import './wallet.css';
import { connect } from "react-redux";
import { BuyerPlatFormActions, MerchantActions, WalletActions } from "../../actions";
import { getDataObj, utcMoment } from '../helper';
import { socketUrl } from '../../baseURL';
import Loader from "react-loader-spinner";
import Spinner from "react-bootstrap/Spinner"
import socketIoClient from 'socket.io-client';
import AutoCompleteBuyerPlatform from '../Includes/AutoCompleteBuyerPlatform';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronLeft } from '@fortawesome/free-solid-svg-icons';
import DatePicker, { DateObject } from "react-multi-date-picker"
import TimePicker from "react-multi-date-picker/plugins/time_picker";
import moment from 'moment';
import { fetchAPI, Api } from '../../services/httpService';
import Swal from 'sweetalert2'
import { addWallet } from '../../actions/WalletActions/actions';

let socket;

class AddWallet extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            buyerId: "",
            merchantId: "",
            transactionDate: "",
            transactionType: "",
            amount: "",
            balance: "",
            description: "",
            currency: "AED",
            buyerIdErrorError: "",
            merchantIdError: "",
            transactionDateError: "",
            transactionTypeError: "",
            amountError: "",
            balanceError: "",
            descriptionError: "",
            currencyError: "",
            submitDisabled: true,
            status: "",
            transferReceiptPdf: "",
            pdfLink: '',
            loader: true,
            buyerPlatformList: [],
            adhocError: '',
            adhoc: false,
            isValidateObj: {
                merchantId: "",
                buyerId: '',
                transactionDate: "",
                transactionType: "",
                amount: "",
            },
            paymentNumber: "",
            isPaymentNumber: false,
            paymentIds: ""
        }
    }

    componentDidMount() {
        // socket = socketIoClient(socketUrl, { query: 'u_id= admin' })
        this.props.getBuyerPlatform().then(() => {
            this.setState({ buyerPlatformList: this.props.buyerPlatforms })
        });
        this.props.getMerchantList().then(() => {
            this.setState({
                loader: false
            })
        });
    }


    setValue = (e) => {
        let errName = e.target.name + "Error";
        this.setState({
            [e.target.name]: e.target.value,
            [errName]: "",
        });
        if (e.target.name === "merchantId" && e.target.value) {
            let selectedMerchat = this.props.merchantList ? this.props.merchantList.find((item) => {
                return item.id == e.target.value
            }) : {}
            const { buyerPlatforms } = selectedMerchat ? selectedMerchat : []
            let tempList = buyerPlatforms ? buyerPlatforms.map((item) => {
                return item.buyerPlatform
            }) : [];
            this.setState({ buyerPlatformList: tempList, buyerId: "" })

        } else if (e.target.name === "merchantId" && !e.target.value) {
            this.setState({ buyerPlatformList: this.props.buyerPlatforms, buyerId: "" })
        }

        if (e.target.name === "status" && e.target.value == 'Adjustment') {
            if (!this.state.adhoc) {
                this.setState({ adhocError: 'Please select Type of Adjustment' })
            }
        }
        else {
            this.setState({ adhocError: '', adhoc: '' })
        }

        let temp = { ...this.state };

        if (e.target.name) {
            if (e.target.name === 'merchantId') {
                temp.isValidateObj.merchantId = e.target.value
            }
            else if (e.target.name === 'buyerId') {
                temp.isValidateObj.buyerId = e.target.value
            }
            else if (e.target.name === 'amount') {
                temp.isValidateObj.amount = e.target.value
            }
            else if (e.target.name === 'transactionDate') {
                temp.isValidateObj.transactionDate = e.target.value
            }
            else if (e.target.name === 'transactionType') {
                temp.isValidateObj.transactionType = e.target.value
            }
        }

        if (temp.merchantId && temp.isValidateObj.buyerId && temp.isValidateObj.amount && temp.isValidateObj.transactionType) {
            this.setState({ submitDisabled: false })
        }
        else {
            this.setState({ submitDisabled: true })
        }
    }
    getItemData = (data) => {
        if (data.id) {
            this.setState({ merchantId: data.id })
            let selectedMerchat = this.props.merchantList ? this.props.merchantList.find((item) => {
                return item.id == data.id
            }) : {}
            const { buyerPlatforms } = selectedMerchat ? selectedMerchat : []
            let tempList = buyerPlatforms ? buyerPlatforms.map((item) => {
                return item.buyerPlatform
            }) : [];
            this.setState({ buyerPlatformList: tempList, buyerPlatformId: '' })

        } else if (!data.id) {
            this.setState({ buyerPlatformList: this.props.buyerPlatforms, buyerPlatformId: '' })
        }
    }

    setTypeAdjustment = (e) => {
        let errName = e.target.name + "Error";
        this.setState({
            [e.target.name]: e.target.value,
            [errName]: e.target.value ? "" : "Please select Type of Adjustment",
        });
    }

    componentDidUpdate(prevProps) {
        if (
            prevProps.addWalletRes !== this.props.addWalletRes &&
            this.props.addWalletRes
        ) {
            const { success, message } = this.props.addWalletRes;

            if (!success) {
                this.setState({ loader: false })
                Swal.fire({
                    icon: 'error',
                    title: message || "Something went wrong",
                    showConfirmButton: false,
                    timer: 2000
                })
            } else {
                const { merchantId } = this.state;

                socket.emit('walletAdd', { merchantId });
                socket.emit('dashboard', { merchantId });

                this.setState({ loader: false }, () => {
                    setTimeout(() => {
                        socket.close();
                        this.props.history.push("/admin/wallet");
                    }, 1000);
                });
            }
        }
    }



    submitData = async () => {
        socket = socketIoClient(socketUrl, { query: 'u_id= admin' })
        let validateData = true;
        this.setState({
            loader: true
        })
        let param = {};
        var date = this.state.transactionDate.unix;
        if (validateData) {
            param = {
                "transactionType": this.state.transactionType,
                "transactionRemarks": this.state.description,
                "amount": this.state.amount,
                "balance": this.state.balance,
                "currency": "AED",
                // "transactionDate": new Date(this.state.transactionDate.replace(/T/, " ")),
                // "transactionDate": this.state.transactionDate ?  moment.unix(date).format("YYYY-MM-DDTHH:mm:ssZ") : "",
                // "transactionDate": this.state.transactionDate ?  moment.unix(date).utc().format("YYYY-MM-DDTHH:mm:ssZ") : "",
                "transactionDate": this.state.transactionDate ? utcMoment(this.state.transactionDate) : "",

                "merchantBuyerPlatformsId": {
                    "merchantId": this.state.merchantId,
                    "buyerPlatformsId": this.state.buyerId
                },
                "status": this.state.status,
                "transferReceiptPdfFile": this.state.transferReceiptPdfFile,
                "adhoc": this.state.adhoc,
                "isManual": true,
                "addedBy": '',
                "phoneNumber": '1234567890',
                // "editInfoArray": "[]"
                paymentIds: this.state.paymentIds,
                paymentNumber: this.state.paymentNumber
            }
            this.props.addWallet(param).then(() => {
                // socket.emit('walletAdd', { merchantId: this.state.merchantId })
                // socket.emit('dashboard', { merchantId: this.state.merchantId })
                // this.setState({
                //     loader: false
                // }, () => {
                //     setTimeout(() => {
                //         socket.close();
                //         this.props.history.push("/admin/wallet");
                //     }, 1000)
                // })
            }).catch((err) => {
                this.setState({
                    loader: false
                })
            });
            // const res = await fetchAPI('POST', `/wallet/generateVerificationOTP?walletId=${this.state.merchantId}`);
            // if (res.success) {
            //     this.setState({ loader: false })
            //     Swal.fire({
            //         title: 'Verify Otp',
            //         html: `
            //             <input type="text" id="otp" class="swal2-input" placeholder="OTP">
            //         `,
            //         confirmButtonText: 'Submit',
            //         focusConfirm: false,
            //         showCloseButton: true,
            //         focusConfirm: true,
            //         allowOutsideClick: false,
            //         confirmButtonColor: 'var(--button-171)',
            //         confirmButtonClass: 'rounded-pill shadow-none px-4',
            //         preConfirm: () => {
            //             const otp = Swal.getPopup().querySelector('#otp').value;
            //             if (!otp) {
            //                 Swal.showValidationMessage('Please enter otp');
            //                 return false;
            //             }
            //             const payload = {
            //                 walletId: this.state.merchantId,
            //                 // editInfoArray: [],
            //                 otp: otp
            //             };
            //             this.setState({ loader: true });
            //             // Return a promise to keep the popup open until the promise resolves
            //             return Api("POST", "/wallet/validateVerificationOTP", payload)
            //                 .then((res) => {
            //                     if (!res.success) {
            //                         Swal.showValidationMessage(
            //                             `<div style="color: red; font-weight: bold;">
            //                                 <i class="fas fa-exclamation-circle"></i> ${res.message || 'Invalid OTP'}
            //                             </div>`
            //                         );
            //                         this.setState({ loader: false });
            //                         return false; // Prevent closing the popup
            //                     }
            //                     return res;
            //                 })
            //                 .catch((error) => {
            //                     Swal.showValidationMessage(`Request failed: ${error.message}`);
            //                     this.setState({ loader: false });
            //                     return false; // Prevent closing the popup
            //                 });
            //         }
            //     }).then((result) => {
            //         if (result.isConfirmed && result.value && result.value.success) {
            //             param.phoneNumber = result.value.body
            //             param.addedBy = result.value.body
            //             this.props.addWallet(param).then(() => {
            //                 // socket.emit('walletAdd', { merchantId: this.state.merchantId })
            //                 // socket.emit('dashboard', { merchantId: this.state.merchantId })
            //                 // this.setState({
            //                 //     loader: false
            //                 // }, () => {
            //                 //     setTimeout(() => {
            //                 //         socket.close();
            //                 //         this.props.history.push("/admin/wallet");
            //                 //     }, 1000)
            //                 // })
            //             }).catch((err) => {
            //                 this.setState({
            //                     loader: false
            //                 })
            //             });

            //         } else {
            //             this.setState({ loader: false });
            //         }
            //     });
            // }
        }

    }

    getJsonData = (arr, id) => {
        return getDataObj(arr, id) ? getDataObj(arr, id) : "";
    }

    setTraditionalPdf = (event) => {
        this.setState({
            [event.target.name]: event.target.files[0],
        })
    }

    onClear = () => {
        this.props.getBuyerPlatform().then(() => {
            // this.setState({ buyerPlatformList: this.props.buyerPlatforms })
        });
        this.setState({
            buyerPlatformList: this.props.buyerPlatforms,
            buyerId: '',
            submitDisabled: true
        })
    }

    // validate Payment number Is already in use or not
    validatePaymentNumber = async (e) => {
        let paymentNumber = e?.target?.value ? e?.target?.value : e;
        const payload = {
            merchantId: this.state.merchantId,
            buyerPlatformId: this.state.buyerId,
            paymentNumber: paymentNumber
        };
        if (paymentNumber && this.state.buyerId && this.state.merchantId) {
            try {
                let res = await Api('post', `/payments/checkValidPaymentNumber`, payload)
                if (!res.success) {
                    Swal.fire({
                        icon: 'error',
                        title: (typeof res.message === 'string') ? res.message : "Server Error",
                        showConfirmButton: false,
                        timer: 1500
                    })
                    this.setState({
                        paymentNumber: '',
                    })
                }
                else {
                    this.setState({
                        paymentNumber: this.state.paymentNumber,
                        paymentIds: res.message
                    })
                }
            } catch (error) {
                console.log('Payment Number Error', error)
            }
        }
    }


    render() {
        const { buyerPlatforms, merchantList } = this.props;
        const { buyerIdError, merchantIdError, buyerId, transactionDateError, transactionTypeError, amountError, balanceError, descriptionError, currencyError, buyerPlatformList, adhocError } = this.state;
        return this.state.loader ? (
            <div className='loader'>
                <Spinner animation="border" />
            </div>
        ) : (
            <div className="invoice-wrap">
                <div style={{ display: "block" }}>
                    <div className="backToHome pb-3" style={{ cursor: "pointer", display: "inline-block" }} >
                        <FontAwesomeIcon className="align-baseline mr-1" icon={faChevronLeft} size="xs" /><span onClick={() => this.props.history.push("/admin/wallet")}>Back</span>
                    </div>
                </div>
                <h2 className="pb-4">Add Balance</h2>
                <div className="searchbox">
                    <div className="row mb-3">
                        <div className="col innerAllEliment">
                            {this.props.match.params.id ?
                                <Form.Group controlId="merchant">
                                    <Form.Label>Merchant</Form.Label>
                                    <Form.Control as="select" name="merchantId" onChange={this.setValue} value={this.state.merchantId}>
                                        <option value="">Select Merchant</option>
                                        {merchantList.map((merchant, index) => (
                                            <option key={index} value={merchant.id} >{merchant.company && merchant.company.tradeName ? merchant.company.tradeName : merchant.user.email}</option>
                                        ))}
                                    </Form.Control>
                                    <Form.Control.Feedback type="invalid">
                                        Please choose a merchant.
                                    </Form.Control.Feedback>
                                </Form.Group>
                                : <AutoCompleteBuyerPlatform
                                    merchantList={merchantList}
                                    getItemData={this.getItemData}
                                    onClear={this.onClear}
                                    merchantName={
                                        this.getJsonData(merchantList, this.state.merchantId)?.company?.tradeName
                                    }
                                />
                            }




                        </div>
                        <div className="col">
                            <Form.Group controlId="BuyerPlatform">
                                <Form.Label>BuyerPlatform</Form.Label>
                                <Form.Control as="select" name="buyerId" value={this.state.buyerId || ''} onChange={this.setValue}>
                                    <option value="">Select BuyerPlatform</option>
                                    {buyerPlatformList && buyerPlatformList.length != 0 && buyerPlatformList.map((buyer, i) => (
                                        <option key={buyer.id} value={buyer.id}>{buyer.name}</option>
                                    ))}
                                </Form.Control>
                                <Form.Text className="danger">
                                    {buyerIdError}
                                </Form.Text>
                            </Form.Group>
                        </div>
                        <div className="col">
                            <Form.Group controlId="transactionDate">
                                <Form.Label>Transaction Date</Form.Label>
                                {/* <Form.Control type="datetime-local"
                                    name="transactionDate" onChange={this.setValue} />
                                <Form.Text className="danger">
                                    {transactionDateError}
                                </Form.Text> */}
                                <DatePicker
                                    name="transactionDate"
                                    format="YYYY-MM-DD hh:mm:ss"
                                    onChange={(value) => {
                                        this.setState({
                                            transactionDate: value
                                        })
                                    }}
                                    containerClassName={"form-control TranDateField"}
                                    value={(this.state.transactionDate || '')}
                                    plugins={[
                                        <TimePicker position="bottom" />,
                                    ]}
                                />
                                <Form.Text className="danger">
                                    {transactionDateError}
                                </Form.Text>
                            </Form.Group>
                        </div>
                        <div className="col">
                            <Form.Group controlId="transactionType">
                                <Form.Label>Transaction Type</Form.Label>
                                <Form.Control as="select" name="transactionType" value={this.state.transactionType || ''} onChange={this.setValue}>
                                    <option value="">Transaction Type</option>
                                    <option value="CR">Credited</option>
                                    <option value="DR">Debited</option>
                                </Form.Control>
                                <Form.Text className="danger">
                                    {transactionTypeError}
                                </Form.Text>
                            </Form.Group>
                        </div>
                    </div>
                    <div className="row mb-3">
                        <div className="col">
                            <Form.Group controlId="transactionAmount">
                                <Form.Label>Transaction Amount</Form.Label>
                                <Form.Control type="text" name="amount" value={this.state.amount || ''} onChange={this.setValue} />
                                <Form.Text className="danger">
                                    {amountError}
                                </Form.Text>
                            </Form.Group>
                        </div>
                        <div className="col">
                            <Form.Group controlId="Balance">
                                <Form.Label>Balance</Form.Label>
                                <Form.Control type="text" disabled name="balance" />
                                <Form.Text className="danger">
                                    {balanceError}
                                </Form.Text>
                            </Form.Group>

                        </div>
                        <div className="col">
                            <Form.Group controlId="Currency/Remarks">
                                <Form.Label>Currency</Form.Label>
                                <Form.Control as="select" name="currency" value="AED" onChange={this.setValue}>
                                    <option value="AED">AED</option>
                                </Form.Control>
                                <Form.Text className="danger">
                                    {currencyError}
                                </Form.Text>
                            </Form.Group>
                        </div>
                        <div className="col">
                            <Form.Group controlId="transactionType">
                                <Form.Label>Status</Form.Label>
                                <Form.Control as="select" name="status" value={this.state.status || ''} onChange={this.setValue}>
                                    <option value="">Status</option>
                                    <option value="Requested">Requested</option>
                                    <option value="Paid">Paid</option>
                                    <option value="Rejected">Rejected</option>
                                    <option value="Adjustment">Adjustment</option>
                                    <option value="Rebate">Rebate</option>
                                </Form.Control>
                                <Form.Text className="danger">
                                    {transactionTypeError}
                                </Form.Text>
                            </Form.Group>
                        </div>
                    </div>
                </div>
                <div className="row">
                    {this.state.status == 'Adjustment' ?
                        <div className="col-lg-3">
                            <Form.Group controlId="transactionType">
                                <Form.Label>Type of Adjustment</Form.Label>
                                <Form.Control as="select" name="adhoc" value={this.state.adhoc || ''} onChange={this.setTypeAdjustment}>
                                    <option value="">Type of Adjustment</option>
                                    <option value={false}>Normal</option>
                                    <option value={true}>Ad-hoc</option>
                                </Form.Control>
                                <Form.Text className="danger">
                                    {adhocError}
                                </Form.Text>
                            </Form.Group>
                        </div>
                        : ''
                    }
                    <div className="col-lg-3">
                        <Form.Group controlId="paymentNumber">
                            <Form.Label>Payment Number</Form.Label>
                            <Form.Control
                                type="text"
                                value={this.state.paymentNumber}
                                name="paymentNumber"
                                onChange={this.setValue}
                                // onBlur={this.validatePaymentNumber}
                                disabled={!(
                                    this.state.merchantId?.trim() &&
                                    this.state.buyerId?.trim()
                                )}
                            />
                            <Form.Control.Feedback type="invalid">
                                Please enter payment number.
                            </Form.Control.Feedback>
                        </Form.Group>
                    </div>
                    <div className="col-lg-3">
                        <Form.Label>Receipt  PDF</Form.Label>
                        {/* {this.props.match.params.id && this.state.traditionalPdf && this.state.pdfLink ? <a href={this.state.pdfLink} target="_blank" className="ml-5" >View Pdf</a> : ''} */}
                        <Form.File
                            type="file"
                            name="transferReceiptPdfFile"
                            onChange={this.setTraditionalPdf}
                        />
                        <Form.Control.Feedback type="invalid">
                            Please enter pdf of request.
                        </Form.Control.Feedback>
                    </div>
                    <div className="col-lg-6">
                        <Form.Group controlId="exampleForm.ControlTextarea1">
                            <Form.Label>Transaction Description/Remarks</Form.Label>
                            <Form.Control as="textarea" name="description" value={this.state.description || ''} rows={7} onChange={this.setValue} />
                            <Form.Text className="danger">
                                {descriptionError}
                            </Form.Text>
                        </Form.Group>
                    </div>
                </div>

                <div className="invoice-meta">
                    {/* <button className="invoice-meta-link mr-4">Done</button> */}
                    {
                        this.state.status == 'Adjustment' && adhocError ? <button disabled={this.state.submitDisabled} className="invoice-meta-link">Save & Exit</button> : <button className="invoice-meta-link" disabled={this.state.submitDisabled} onClick={this.submitData} >Save & Exit</button>
                    }
                </div>
            </div>
        )
    }
};

const mapStateToProps = ({ BuyerPlatFormReducers, MerchantListReducer, WalletListReducer }) => {
    return {
        buyerPlatforms: BuyerPlatFormReducers.buyerPlatforms,
        merchantList: MerchantListReducer.merchantList.content,
        addWalletRes: WalletListReducer.addWalletRes
    };
}

const mapDispatchToProps = {
    getBuyerPlatform: BuyerPlatFormActions.getBuyerPlatform,
    getMerchantList: MerchantActions.getMerchantList,
    addWallet: WalletActions.addWallet,
}


export default connect(mapStateToProps, mapDispatchToProps)(AddWallet);